
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.955","height":"15.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"data-name":"Path 31848","d":"M9.659 6.591a.75.75 0 01-.53-1.28l2.015-2.015L9.129 1.28a.75.75 0 011.06-1.06l2.545 2.545a.75.75 0 010 1.061l-2.545 2.545a.748.748 0 01-.53.22z"}}),_c('path',{attrs:{"data-name":"Path 31849","d":"M.75 7.863a.75.75 0 01-.75-.75V5.84a3.3 3.3 0 013.3-3.3h8.909a.75.75 0 010 1.5H3.295a1.8 1.8 0 00-1.8 1.8v1.273a.75.75 0 01-.745.75z"}}),_c('path',{attrs:{"data-name":"Path 31850","d":"M3.295 15.5a.748.748 0 01-.53-.22L.22 12.735a.75.75 0 010-1.061l2.545-2.545a.75.75 0 011.061 1.06l-2.015 2.015 2.015 2.015a.75.75 0 01-.53 1.28z"}}),_c('path',{attrs:{"data-name":"Path 31851","d":"M9.659 12.954H.75a.75.75 0 010-1.5h8.909a1.8 1.8 0 001.8-1.8V8.386a.75.75 0 011.5 0v1.273a3.3 3.3 0 01-3.3 3.295z"}})])])
          )
        }
      }
    